/**
 * @name isBitValueTrue
 * @description This function checks if the argument is 1 (true). If this function returns false it doesn't mean that the argument is 0
 * @param value
 * @returns {boolean}
 */
export const isBitValueTrue = (value) => {
    return Number(value) === 1;
};
/**
 * @name isBitValueFalse
 * @description This function checks if the argument is 0 (false). If this function returns false it doesn't mean that the argument is 1
 * @param value
 * @returns {boolean}
 */
export const isBitValueFalse = (value) => {
    return Number(value) === 0;
};
